import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="privacy-page">
      <Link to="/" className="btn-ghost text-xs inline-flex items-center gap-2 mb-8" data-testid="privacy-back">
        <ArrowLeft size={14} /> Volver
      </Link>
      <div className="overline mb-3" style={{ color: "var(--brand-primary)" }}>Legal</div>
      <h1 className="font-serif text-4xl md:text-5xl font-light mb-6" style={{ color: "var(--text-primary)" }}>
        Política de <em style={{ color: "var(--brand-primary)" }}>Privacidad</em>
      </h1>
      <p className="text-xs mb-10" style={{ color: "var(--text-muted)" }}>Última actualización: febrero 2026</p>

      <Section title="Datos que recopilamos">
        Email, nombre artístico, número de WhatsApp/teléfono (opcional), ciudad, fotos, video de verificación e identificación
        oficial. Para visitantes únicamente recopilamos email y, opcionalmente, teléfono.
      </Section>

      <Section title="Documentos de verificación">
        Las imágenes de tu INE, selfie y video <strong>se almacenan cifradas en Cloudinary</strong>, son visibles
        únicamente para administradores autorizados y nunca se publican en perfiles. Se conservan mientras tu cuenta esté
        activa para auditoría legal.
      </Section>

      <Section title="Cookies y sesión">
        Usamos cookies <strong>HTTP-only seguras</strong> para mantener tu sesión iniciada. No empleamos cookies de
        seguimiento publicitario de terceros.
      </Section>

      <Section title="Tus derechos (ARCO)">
        Puedes solicitar acceso, rectificación, cancelación u oposición al tratamiento de tus datos personales escribiendo
        a <a href="mailto:privacidad@pk2scarlett.com" style={{ color: "var(--brand-primary)" }}>privacidad@pk2scarlett.com</a>.
      </Section>

      <Section title="Eliminación de cuenta">
        Puedes eliminar tu cuenta desde el panel de Ajustes. Los documentos de verificación se conservan 6 meses por
        obligaciones legales y luego se eliminan automáticamente.
      </Section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-serif text-2xl mb-3" style={{ color: "var(--text-primary)" }}>{title}</h2>
      <div className="text-sm" style={{ color: "var(--text-secondary)", lineHeight: 1.8 }}>{children}</div>
    </section>
  );
}
